type UnitStep = { factor: number; unit: string };

const UNIT_CHAINS: Record<string, UnitStep[]> = {
  g: [
    { factor: 1000, unit: "kg" },
    { factor: 1000, unit: "t" },
    { factor: 1000, unit: "kt" },
    { factor: 1000, unit: "Mt" },
  ],
  kg: [
    { factor: 1000, unit: "t" },
    { factor: 1000, unit: "kt" },
    { factor: 1000, unit: "Mt" },
  ],
  t: [
    { factor: 1000, unit: "kt" },
    { factor: 1000, unit: "Mt" },
  ],
  gCO2e: [
    { factor: 1000, unit: "kgCO2e" },
    { factor: 1000, unit: "tCO2e" },
    { factor: 1000, unit: "ktCO2e" },
    { factor: 1000, unit: "MtCO2e" },
  ],
  kgCO2e: [
    { factor: 1000, unit: "tCO2e" },
    { factor: 1000, unit: "ktCO2e" },
    { factor: 1000, unit: "MtCO2e" },
  ],
  tCO2e: [
    { factor: 1000, unit: "ktCO2e" },
    { factor: 1000, unit: "MtCO2e" },
  ],
  mL: [{ factor: 1000, unit: "L" }],
  L: [{ factor: 1000, unit: "m³" }],
  mm: [{ factor: 1000, unit: "m" }],
  m: [{ factor: 1000, unit: "km" }],
  m2: [
    { factor: 10000, unit: "ha" },
    { factor: 100, unit: "km²" },
  ],
  ha: [{ factor: 100, unit: "km²" }],
  Wh: [
    { factor: 1000, unit: "kWh" },
    { factor: 1000, unit: "MWh" },
    { factor: 1000, unit: "GWh" },
  ],
  kWh: [
    { factor: 1000, unit: "MWh" },
    { factor: 1000, unit: "GWh" },
  ],
  MWh: [{ factor: 1000, unit: "GWh" }],
  J: [
    { factor: 1000000, unit: "MJ" },
    { factor: 1000, unit: "GJ" },
  ],
  MJ: [{ factor: 1000, unit: "GJ" }],
};

export function convertWithUnit(
  val: number,
  unit: string | undefined,
): { value: number; unitDisplay: string | undefined } {
  if (!unit) return { value: val, unitDisplay: unit };
  const chain = UNIT_CHAINS[unit];
  if (!chain) return { value: val, unitDisplay: unit };
  let v = val;
  let u = unit;
  for (const step of chain) {
    if (Math.abs(v) < step.factor) break;
    v /= step.factor;
    u = step.unit;
  }
  return { value: v, unitDisplay: u };
}

export function formatLargeNumber(val: number): string {
  if (Math.abs(val) >= 1e12) return (val / 1e12).toFixed(1) + "T";
  if (Math.abs(val) >= 1e9) return (val / 1e9).toFixed(1) + "B";
  if (Math.abs(val) >= 1e6) return (val / 1e6).toFixed(1) + "M";
  if (Math.abs(val) >= 1e3) return (val / 1e3).toFixed(1) + "K";
  return val.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

// Factor that converts `unit` up to `target` along its unit chain (1 if not
// convertible or identical).
export function conversionFactor(
  unit: string | undefined,
  target: string | undefined,
): number {
  if (!unit || !target || unit === target) return 1;
  const chain = UNIT_CHAINS[unit];
  if (!chain) return 1;
  let factor = 1;
  let u = unit;
  for (const step of chain) {
    if (u === target) break;
    factor *= step.factor;
    u = step.unit;
    if (u === target) break;
  }
  return factor;
}
